const AboutData = {
  image: require("../assets/Images/about.png"),
  description: [
    "DevOps Engineer with hands-on experience in building and operating automated CI/CD pipelines, GitOps-based deployments, and cloud-native infrastructure across multi-cloud environments including AWS, GCP, and Azure.",

    "I work at the intersection of development, operations, and security, with a strong focus on automation, reliability, scalability, and continuous improvement. My experience includes Kubernetes-based application delivery using Docker, Helm, and GitOps practices.",

    "I have integrated security and quality gates into delivery pipelines using tools such as Trivy, OWASP dependency scanning, and SonarQube. Currently, I am exploring MLOps, AIOps, and serverless architectures to understand how modern platforms evolve and scale."
  ],
};

export default AboutData;
